export default "__VITE_ASSET__03f58a75__"